import "./spinner.styles.scss";

function Spinner() {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container"></div>
    </div>
  );
}

export default Spinner;
